import { cn } from '@/lib/utils';
import { Session } from '@/utils/types';

interface PurchaseDetailsProps {
  selectedSeats: string[];
  selectedSession: Session | null;
  lng: string;
  className?: string;
}

export default function PurchaseDetails({ selectedSeats, selectedSession, lng, className }: PurchaseDetailsProps) {
  return (
    <ul className={cn('space-y-4', className)}>
      <li className='flex flex-col gap-2 border-t border-gray2 pt-4'>
        <h3 className='mb-2 text-3xl font-bold max-sm:text-2xl'>Assentos</h3>
        <div className='min-h-10 flex flex-wrap items-center gap-2'>
          {selectedSeats.length > 0 ? (
            selectedSeats.map((seatCode, index) => {
              return (
                <span
                  key={index}
                  className='inline-flex h-12 w-12 items-center justify-center bg-primary text-lg font-light text-white max-sm:text-base'>
                  {seatCode.replace(/-/g, '')}
                </span>
              );
            })
          ) : (
            <span className='text-base text-zinc-500'>Nenhum assento selecionado</span>
          )}
        </div>
      </li>
    </ul>
  );
}
